/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { IInventoryFilterState } from "../types";

export const setSelectedStatusAction = (state: IInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedStatus = action.payload;
};

export const setSelectedModelAction = (state: IInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedModel = action.payload;
};

export const setSelectedStateAction = (state: IInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedState = action.payload;
};

export const setSelectedParentAction = (state: IInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedParent = action.payload;
};

export const setSelectedTechnologyAction = (state: IInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedTechnology = action.payload;
};

export const setSearchKeywordAction = (state: IInventoryFilterState, action: PayloadAction<string>) => {
  state.searchKeyword = action.payload;
};

export const setSelectedViewAction = (state: IInventoryFilterState, action: PayloadAction<"radionodes" | "cells">) => {
  state.selectedView = action.payload;
};

export const setRegionFilterIdsAction = (state: IInventoryFilterState, action: PayloadAction<string[]>) => {
  state.regionFilterIds = action.payload;
};

export const resetInventoryFiltersAction = (state: IInventoryFilterState) => {
  state.selectedStatus = "";
  state.selectedModel = "";
  state.selectedState = "";
  state.selectedParent = "";
  state.selectedTechnology = "";
  state.searchKeyword = "";
  state.regionFilterIds = [];
  // Don't reset selectedView - keep the current tab active
};
